<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Cooperation",
};
</script>

<style scoped></style>
